<template>
  <div class="bordered bgWhite">
    <div class="filter row">
      <div class="field field-select filter-category col s50 m33">
        <label for="category">Kategorie</label>
        <select id="category" name="category" v-model="category">
          <option value="">Kategorie</option>
          <option
            v-for="category in categories"
            :value="category"
            :key="category"
            :selected="category === categoryValue"
          >
            {{ category }}
          </option>
        </select>
      </div>

      <div class="field field-select filter-bath col s50 m33">
        <label for="bath">Ort</label>
        <select id="bath" name="bath" v-model="bath">
          <option value="" selected>Ort</option>
          <option v-for="bath in baths" :value="bath" :key="bath">
            {{ bath }}
          </option>
        </select>
      </div>

      <div class="field field-checkbox filter-freeCourses col m33">
        <input
          type="checkbox"
          id="freeCourses"
          name="freeCourses"
          value="true"
          v-model="freeCourses"
        />
        <label for="freeCourses">Nur freie Kurse zeigen</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseFilter",
  props: ["courses", "baths", "categories"],
  data() {
    return {
      freeCoursesValue: false,
      bathValue: "",
      categoryValue: ""
    };
  },
  computed: {
    bath: {
      set: function(value) {
        this.bathValue = value;
        localStorage.setItem("filterBath", value);
        this.$emit("update:bath", value);
      },
      get: function() {
        return this.bathValue;
      }
    },
    category: {
      set: function(value) {
        this.categoryValue = value;
        localStorage.setItem("filterCategory", value);
        this.$emit("update:category", value);
      },
      get: function() {
        return this.categoryValue;
      }
    },
    freeCourses: {
      set: function(value) {
        this.freeCoursesValue = value;
        localStorage.setItem("filterFreeCourses", value);
        this.$emit("update:freeCourses", value);
      },
      get: function() {
        return this.freeCoursesValue;
      }
    }
  },
  created() {
    localStorage.setItem("filterBath", "");
    const filterBath = localStorage.getItem("filterBath");
    if (this.bath === "" && filterBath !== null) this.bath = filterBath;

    if (this.$route.params.filterCategory === undefined) {
      const filterCategory = localStorage.getItem("filterCategory");
      if (this.category === "" && filterCategory !== null)
        this.category = filterCategory;
    }

    const filterFreeCourses = localStorage.getItem("filterFreeCourses");
    if (this.freeCourses === false && filterFreeCourses !== null)
      this.freeCourses = filterFreeCourses;
  },
  watch: {
    courses: function() {
      if (this.$route.params.filterCategory !== undefined) {
        this.category = this.$route.params.filterCategory;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.filter {
  .field {
    &.field-select {
      margin-top: 0;
    }

    &.field-checkbox {
      margin-bottom: 0;
    }
  }

  @media (min-width: 980px) {
    .field {
      margin: 0;

      &.filter-freeCourses {
        transform: translateY(10%);
      }
    }
  }
}
</style>
